import React, { Component } from 'react';
import CommToolContext from '../../common/comm_tool_context';
import { Grid, Row, Col } from 'react-flexbox-grid';
import {
  getIPSProject,
  getIpsTeamRoleMembers,
  getAllCommentsIpsDT,
  getAllDropDownOptions,
} from '../../../api';
import DataTrackersTabs from './datatra_tabs';
import Spinner, { spinnerOff, spinnerOn } from 'components/Spinner';

class DataProject extends Component {
  constructor(props) {
    super(props);

    this.state = {
     
      projectInfo: {
        bpid: props.match.params.bpid,
          workOrder: props.match.params.workOrder,
        stationName:decodeURIComponent(props.match.params.station_name)
        
      },
      // props.match.params.projectId
    };
  }

  async componentDidMount() {
    spinnerOn()
    const getProject = getIPSProject(this.state.projectInfo);
    const getTeamMembers = getIpsTeamRoleMembers(this.state.projectInfo);
    
    const getAllDropdownOptions = getAllDropDownOptions();

    const result = await Promise.allSettled([
      getProject,
      getTeamMembers,
      
      getAllDropdownOptions
    ]);
spinnerOff()
    const project = result[0].value;
    const teamMembers = result[1].value;
    
    const allDropDownOptions = result[2].value

    this.setState({
      project: project,
      teamMembers: teamMembers,
      
      allDropDownOptions:allDropDownOptions
    });
  }
  getProjectTabStatus(){
    if (this.props.history.location) {
      let pathname = this.props.history.location.pathname;
      if (pathname) {
        if (pathname.includes("datatracker_progress")) {
          return "datatracker_progress";
        } else if (pathname.includes("datatracker_complete")) {
          return "datatracker_complete";
        } else if (pathname.includes("datatracker_hold")) {
          return "datatracker_hold";
        } else {
          return null;
        }

      }
    }

}

  render() {
    const { project, teamMembers,allDropDownOptions } = this.state;
    let status = this.getProjectTabStatus();
    
    return (
      <CommToolContext.Consumer>
        {(context) => (
          <React.Fragment>
            <Grid fluid>
              <Row>
                <Col xs>
                  <Col className='pt-4' >
                <Spinner/>
                </Col>
                  {project && (
                    <DataTrackersTabs
                      project={project}
                      teamMembersList={teamMembers}
                      allDropDownOptions={allDropDownOptions}
                      context={context}
                      status={status}
                    />
                  )}
                </Col>
              </Row>
            </Grid>
          </React.Fragment>
        )}
      </CommToolContext.Consumer>
    );
  }
}

DataProject.contextType = CommToolContext;
export default DataProject;
